import ComingSoon from './ComingSoon';
import { Users } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

const UserManagement = () => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>User Management</CardTitle>
      </CardHeader>
      <CardContent>
        <ComingSoon
          title="User Management"
          description="User administration features including creating, editing, and managing user access will be available soon."
          icon={<Users className="h-8 w-8 text-blue-600" />}
        />
      </CardContent>
    </Card>
  );
};

export default UserManagement;
